<div class="outer-container">
  <div class="up-arrow">
    <div class="inner-triangle"></div>
  </div>
  <div class="bg-white border-ratoong prompt-container">
    <span (click)="closePrompt()" class="close">&#x2715;</span>
    <ng-content></ng-content>
  </div>
</div>
